import { Panel } from '../../../../common/panel'
import { Content } from './Content'
import { Header } from './header'

export const Macroeconomics = () => {
  return (
    <Panel
      id="macroeconomicsId"
      isI18n
      height={700}
      label="industryOverview.macroeconomics.MACROECONOMICS"
    >
      <div className="h100 flexColumn">
        <Header />
        <div className="flex1">
          <Content />
        </div>
      </div>
    </Panel>
  )
}
